import React, {useContext} from 'react';
import LandingAreasSliderWithoutImg from "../../property/landing/landing_areas_slider_without_img";
import {AgenciesDispatcherContext} from "../../../providers/agencies_provider";
import {scrollToTop} from "../../../helpers/helpers";
import {makeAgenciesSearchUrl} from "./helpers";
import {useRouter} from "next/router";

const ShomalCitiesSlider = ({className, pageType, handleItemsLists}) => {
    const agenciesDispatcher = useContext(AgenciesDispatcherContext);
    const router = useRouter();

    const specialDistricts = [
        {id: 3614, name: 'چمستان', url: '/املاک-چمستان/مشاورین-املاک'},
        {id: 1367, name: 'نور', url: '/املاک-نور/مشاورین-املاک'},
        {id: 1368, name: 'نوشهر', url: '/املاک-نوشهر/مشاورین-املاک'},
        {id: 1364, name: 'محمود‌آباد', url: '/املاک-محمود-آباد/مشاورین-املاک'},
        {id: 1356, name: 'رامسر', url: '/املاک-رامسر/مشاورین-املاک'},
        {id: 3159, name: 'رویان', url: '/املاک-رویان/مشاورین-املاک'},
        {id: 1617, name: 'بندر انزلی', url: '/املاک-بندر-انزلی/مشاورین-املاک'},
        {id: 1634, name: 'آمل', url: '/املاک-آمل/مشاورین-املاک'},
        {id: 1353, name: 'تنکابن', url: '/املاک-تنکابن-(-شهسوار-)/مشاورین-املاک'},
        {id: 3661, name: 'سرخ‌رود', url: '/املاک-سرخ-رود/مشاورین-املاک'},
        {id: 6377, name: 'زیباکنار', url: '/املاک-زیباکنار/مشاورین-املاک'},
        {id: 1358, name: 'متل‌قو', url: '/املاک-سلمانشهر-(-متل-قو-)/مشاورین-املاک'},
        {id: 1355, name: 'چالوس', url: '/املاک-چالوس/مشاورین-املاک'},
        {id: 1351, name: 'بابلسر', url: '/املاک-بابلسر/مشاورین-املاک'},
        {id: 1077, name: 'لاهیجان', url: '/املاک-لاهیجان/مشاورین-املاک'},
        {id: 3972, name: 'عباس‌آباد', url: '/املاک-عباس-آباد/مشاورین-املاک'},
        {id: 1361, name: 'کلاردشت', url: '/املاک-کلاردشت/مشاورین-املاک'},
        {id: 1074, name: 'کیاشهر', url: '/املاک-کیاشهر/مشاورین-املاک'},
    ];

    const breakpoints = {
        1024: {
            slidesPerView: 5,
        },
        768: {
            slidesPerView: 4.2,
        },
        365: {
            slidesPerView: 2.2,
        },
        320: {
            slidesPerView: 1.8,
        }
    };

    const handleSkeleton = (show) => {
        agenciesDispatcher({
            type: 'SET_SKELETON',
            payload: {
                skeleton: show
            }
        })
    }

    const handleClickOnItems = (item) => {
        scrollToTop();

        handleSkeleton(true);

        handleItemsLists(pageType, item.id, '', 1);

        makeAgenciesSearchUrl(pageType, item.id, '').then(url => {
            if (url) {
                router.push('/users/agencies', url, {shallow: true});
            }
        })
    }

    return (
        <div className="container sm-fluid">
            <LandingAreasSliderWithoutImg
                city_id={3198}
                items={specialDistricts}
                breakpoints={breakpoints}
                firstTitle="مشاورین املاک"
                href="/users/agencies"
                showOtherAreas={false}
                onClickOnItems={handleClickOnItems}
            />
        </div>
    );
};

export default React.memo(ShomalCitiesSlider);
